<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource">
      <!-- MPI Column -->
      <ng-container matColumnDef="masterPatientIdentifier">
        <th mat-header-cell *matHeaderCellDef>MPI</th>
        <td mat-cell *matCellDef="let patient">{{ patient.masterPatientIdentifier }}</td>
      </ng-container>
  
      <!-- Full Name Column -->
      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef>Full Name</th>
        <td mat-cell *matCellDef="let patient">{{ patient.fullName }}</td>
      </ng-container>
  
      <!-- DOB Column -->
      <ng-container matColumnDef="DOB">
        <th mat-header-cell *matHeaderCellDef>DOB</th>
        <td mat-cell *matCellDef="let patient">{{ patient.DOB | date : 'MM/dd/yyyy' }}</td>
      </ng-container>
  
      <!-- Gender Column -->
      <ng-container matColumnDef="gender">
        <th mat-header-cell *matHeaderCellDef>Gender</th>
        <td mat-cell *matCellDef="let patient">{{ patient.gender }}</td>
      </ng-container>
  
      <!-- Active in Reggie Column -->
      <ng-container matColumnDef="isActiveInReggie">
        <th mat-header-cell *matHeaderCellDef>Active in Reggie</th>
        <td mat-cell *matCellDef="let patient">{{ patient.isActiveInReggie }}</td>
      </ng-container>
  
      <!-- Active in EDS Column -->
      <ng-container matColumnDef="activeInEDS">
        <th mat-header-cell *matHeaderCellDef>Active in EDS</th>
        <td mat-cell *matCellDef="let patient">{{ patient.activeInEDS }}</td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" 
          (click)="patientDetails(row)" 
          class="clickable-row"></tr>
    </table>
  </div>